import { computed } from "vue";
import { usePermissions } from "../../util/permissions";

export default function useNgpDialog() {
  const { isAdmin } = usePermissions();

  const gpModalClass = computed(() => (isAdmin.value ? "pb-[50px]" : ""));
  const gpModalTop = computed(() => (isAdmin.value ? "z-1058" : ""));

  return { gpModalClass, gpModalTop };
}
